"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _cargoTrack = require("@/api/vipCargo/cargoTrack");
var _blPrint = require("@/api/vipCargo/blPrint");
var _Export2Excel = require("@/utils/Export2Excel");
var _blPrint2 = _interopRequireDefault(require("./blPrint.vue"));
var _validate = require("@/utils/validate");
var _indexHotSkipBlNo = _interopRequireDefault(require("./components/indexHotSkipBlNo"));
var _indexHotActualDays = _interopRequireDefault(require("./components/indexHotActualDays"));
var _indexHotEstimatedDays = _interopRequireDefault(require("./components/indexHotEstimatedDays"));
var _indexHotSkipVessel = _interopRequireDefault(require("./components/indexHotSkipVessel"));
var _indexHotAgtd = _interopRequireDefault(require("./components/indexHotAgtd"));
var _indexHotAgta = _interopRequireDefault(require("./components/indexHotAgta"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { remotePortList } from '@/api/query/port'
// import { remoteVesselList } from '@/api/query/vessel'
var _default = exports.default = {
  name: 'vipCargoTrack',
  components: {
    blPrint: _blPrint2.default,
    indexHotSkipBlNo: _indexHotSkipBlNo.default,
    indexHotActualDays: _indexHotActualDays.default,
    indexHotEstimatedDays: _indexHotEstimatedDays.default,
    indexHotSkipVessel: _indexHotSkipVessel.default,
    indexHotAgtd: _indexHotAgtd.default,
    indexHotAgta: _indexHotAgta.default
  },
  data: function data() {
    var _this = this;
    return {
      hotSettings: {
        dragCheck: true,
        height: '390px',
        width: 'width: 100%',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        showSelection: true,
        readOnly: true,
        columnSorting: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      hotSettings1: {
        dragCheck: true,
        height: '390px',
        width: 'width: 100%',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        showSelection: false,
        readOnly: true,
        columnSorting: true
        // fixedColumnsLeft: 1
      },
      form: {
        freightNameCn: '',
        vesselCode: '',
        voyageNo: '',
        blNo: '',
        por: '',
        pol: '',
        pod: '',
        del: '',
        etd: '',
        atd: '',
        eta: '',
        ata: ''
      },
      nacList: [],
      titleName: '',
      tableBaseInfoData: [],
      tableContainerData: [],
      tableMovementData: [],
      loading: null,
      dialogTableVisible: false,
      pickerOneDate: '',
      pickerOptions: {
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
            minDate = _ref.minDate;
          _this.pickerOneDate = minDate.getTime();
          if (maxDate) {
            _this.pickerOneDate = '';
          }
        },
        disabledDate: function disabledDate(time) {
          if (_this.pickerOneDate !== '') {
            var day14 = (91 - 1) * 24 * 3600 * 1000;
            var beginTime = _this.pickerOneDate - day14;
            var endTime = _this.pickerOneDate + day14;
            return time.getTime() > endTime || time.getTime() < beginTime;
          }
          return false;
        }
      },
      multipleSelection: []
    };
  },
  created: function created() {
    var _this2 = this;
    (0, _cargoTrack.getNacList)().then(function (response) {
      _this2.nacList = response.data;
    });
  },
  methods: {
    porChange: function porChange(val, selectRows) {
      this.form.por = selectRows.portName;
    },
    polChange: function polChange(val, selectRows) {
      this.form.pol = selectRows.portName;
    },
    podChange: function podChange(val, selectRows) {
      this.form.pod = selectRows.portName;
    },
    delChange: function delChange(val, selectRows) {
      this.form.del = selectRows.portName;
    },
    vesselChange: function vesselChange(value, selectedRows) {
      this.form.vesselCode = selectedRows.vesselName;
    },
    validateNull: _validate.validateNull,
    getDiffDay: function getDiffDay(new_date, old_date) {
      //当datestring=2017-02-16时，解析的结果为：Thu Feb 16 2017 08:00:00 GMT+0800 (中国标准时间)多了八个小时
      var newDate = new_date.replace('-', '/');
      var oldDate = old_date.replace('-', '/');
      var myDate_1 = new Date(newDate);
      var myDate_2 = new Date(oldDate);
      var subtime = (myDate_1 - myDate_2) / 1000; //计算时间差,并将毫秒转化为秒
      var days = parseInt(subtime / 86400); //天  24*60*60*1000
      return this.isInteger(days + (subtime / 3600 - 24 * days) / 24) ? days + (subtime / 3600 - 24 * days) / 24 : (days + (subtime / 3600 - 24 * days) / 24).toFixed(1); //天
    },
    isInteger: function isInteger(n) {
      return parseInt(n) === parseFloat(n);
    },
    /**
     * 点击编号跳转界面
     * @param row
     */
    handleBLNo: function handleBLNo(row, column, event, cell) {
      var routeUrl = this.$router.resolve({
        path: '/topMenu/cargoTrack',
        query: {
          blNo: row.blNo
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    handleVesselCode: function handleVesselCode(row, column, event, cell) {
      var routeUrl = this.$router.resolve({
        path: '/topMenu/vesselMovementSearch',
        query: {
          vesselCode: row.vesselCode,
          vesselName: row.vesselName
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    /**
     *  查询
     * */
    toSearch: function toSearch() {
      var _this3 = this;
      if (!this.validateNull(this.form.blNo) || !this.validateNull(this.form.vesselCode) && !this.validateNull(this.form.voyageNo) || !this.validateNull(this.form.etd) || !this.validateNull(this.form.atd) || !this.validateNull(this.form.eta) || !this.validateNull(this.form.ata)) {
        this.loading = (0, _utils.load)();
        this.tableBaseInfoData = [];
        this.tableContainerData = [];
        (0, _cargoTrack.vipCargoTrack)(Object.assign({}, this.form)).then(function (response) {
          var data = response.data;
          _this3.tableBaseInfoData = data;
        }).finally(function () {
          _this3.loading.close();
        });
      } else {
        this.$message({
          message: this.$i18n.locale === 'zh' ? '请输入VVL/BL_NO/ETD/ATD/ETA/ATA 其中任意一个查询条件！' : 'Please enter any of the query conditions, VVL/BL_NO/ETD/ATD/ETA/ATA!'
        });
      }
    },
    /**
     * 箱信息
     * */
    rowClick: function rowClick(row) {
      var _this4 = this;
      this.tableContainerData = [];
      (0, _cargoTrack.getVipCargoContainer)(row.bookingHeadId).then(function (response) {
        var data = response.data;
        _this4.tableContainerData = data;
      });
    },
    /**
     * 箱动态信息
     * */
    rowContainerClick: function rowContainerClick(row) {
      var _this5 = this;
      this.titleName = row.record.containerNo;
      this.dialogTableVisible = true;
      (0, _cargoTrack.getContainerMovement)({
        blNo: row.record.blNo,
        containerNo: row.record.containerNo
      }).then(function (response) {
        var data = response.data;
        _this5.tableMovementData = data;
      });
    },
    /**
     * 导出excel
     */
    exportExcel: function exportExcel() {
      (0, _Export2Excel.export_table_to_excel)('#out-table', 'vipCargoTrack');
    },
    /**
     * 多选
     * @param val
     */
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 打印预览
     */
    printView: function printView() {
      var _this6 = this;
      if (this.multipleSelection.length > 0) {
        (0, _blPrint.batchPrintJapan)({
          bookingHeadId: this.multipleSelection[0].bookingHeadId
        }).then(function (response) {
          var resultData = response.data;
          _this6.$refs.childPrint.resetBlPrintForm();
          _this6.$refs.childPrint.blPrintForm = resultData.printInfo[0];
          _this6.$refs.childPrint.dialogTableVisible2 = true;
        });
      } else {
        this.$message({
          message: 'Please choose one data！'
        });
      }
    },
    reset: function reset() {
      this.form = {
        vesselCode: '',
        voyageNo: '',
        blNo: '',
        por: '',
        pol: '',
        pod: '',
        del: '',
        etd: '',
        atd: '',
        eta: '',
        ata: ''
      };
    }
  }
};